import React, { useState } from 'react';
import PropTypes from 'prop-types';

export const ProfilePinNumberVerification = ({ handleSubmitPin }) => {
    const [pin, setPin] = useState('');

    return (
        <>
            <p data-testid="phonePinInfo">Skriv inn koden du fikk tilsendt på SMS</p>
            <div className="input input--text input--kill-bottom-margin mb-8">
                <input value={pin} placeholder="Kode" data-testid="phonePinInput" onChange={(event) => setPin(event.target.value)} />
            </div>
            <button className="button button--secondary" data-testid="phonePinSubmit" disabled={!pin} onClick={() => handleSubmitPin(pin)}>
                Send
            </button>
        </>
    );
};

ProfilePinNumberVerification.propTypes = {
    handleSubmitPin: PropTypes.func.isRequired,
};
